import React, { useState } from 'react';
import { ColumviQuizSlide } from './components/ColumviQuizSlide';
import { ColumviResultSlide } from './components/ColumviResultSlide';
import { ColumviCtaSlide } from './components/ColumviCtaSlide';
type SlideType = 'quiz' | 'result' | 'cta';
export function App() {
  const [currentSlide, setCurrentSlide] = useState<SlideType>('quiz');
  const [isCorrect, setIsCorrect] = useState(false);
  const handleAnswerSelect = (answerId: string) => {
    const correct = answerId === 'b';
    setIsCorrect(correct);
    setTimeout(() => setCurrentSlide('result'), 500);
  };
  const handleResultCta = () => {
    setCurrentSlide('cta');
  };
  return <div className="min-h-screen w-full flex justify-center items-center p-4" style={{
    background: '#1a1a2e'
  }} data-id="element-0">
      <div className="w-full max-w-[400px] aspect-[9/16] relative overflow-hidden shadow-2xl rounded-2xl" data-id="element-1">
        {currentSlide === 'quiz' && <ColumviQuizSlide question="In relapsed 2L+ DLBCL, what most determines survival outcomes?" context="Later-line disease often reflects resistant biology." answers={[{
        id: 'a',
        text: 'A) Increasing chemotherapy intensity'
      }, {
        id: 'b',
        text: 'B) Achieving deep, immune-mediated tumour control'
      }, {
        id: 'c',
        text: 'C) Extending time between treatment cycles'
      }]} onAnswerSelect={handleAnswerSelect} data-id="element-2" />}

        {currentSlide === 'result' && <ColumviResultSlide isCorrect={isCorrect} correctAnswer="Achieving deep, immune-mediated tumour control" peerPercentage={74} insightHeadline="In relapsed or refractory DLBCL, survival is strongly associated with achieving deep and durable responses." insightBody={['Strategies that actively engage the immune system to target malignant B cells represent a shift beyond reliance on cytotoxic intensity alone.']} visualUrl="https://cdn.magicpatterns.com/uploads/7ACa9FZctKQW7zUM1g4GVF/Screenshot_2026-02-21_at_09.01.30.png" expandedHeadline="In relapsed or refractory DLBCL, survival is strongly associated with achieving deep and durable responses." expandedBody={['Strategies that actively engage the immune system to target malignant B cells represent a shift beyond reliance on cytotoxic intensity alone.']} ctaLabel="See the full clinical data →" onCta={handleResultCta} data-id="element-3" />}

        {currentSlide === 'cta' && <ColumviCtaSlide heading="Explore how Columvi links T cells to lymphoma cells to trigger targeted killing." subheading="Review efficacy data, mechanism, and pathway positioning." primaryLabel="View full evidence" primaryUrl="https://www.columvi-hcp.com/efficacy/trial-information.html" secondaryLabel="Explore mechanism of action" secondaryUrl="https://www.columvi-hcp.com/about/how-columvi-works.html" data-id="element-4" />}
      </div>
    </div>;
}